import withUserRoute from '@/components/auth/withUserRoute';
import Header from '@/components/global/Header';
import { ssrWebsiteUserData } from '@/services/user.service';
import { GetServerSideProps, NextPage } from 'next';
import React from 'react';

export const getServerSideProps: GetServerSideProps = ssrWebsiteUserData;

const WebsiteOnlineDoctor: NextPage = () => {
    return (
        <div>
            <Header showSearch showSupportInfo />
        </div>
    );
};

export default withUserRoute(WebsiteOnlineDoctor);
